import { FC } from 'react'

import DocumentSignature from '@/assets/app-icons/document-signature.svg?react'
import EForm from '@/assets/app-icons/e-form.svg?react'
import IdentityVerification from '@/assets/app-icons/identity-verification.svg?react'
import OneTimePasscode from '@/assets/app-icons/one-time-passcode.svg?react'
import Passkeys from '@/assets/app-icons/passkeys.svg?react'
import Payments from '@/assets/app-icons/payments.svg?react'
import GatewayPayments from '@/assets/app-icons/gateway-payments.svg?react'

type AppColor = 'blue' | 'green' | 'orange' | 'teal' | 'purple' | 'rose' | 'copper'

const passkeysApp: AppInfo = {
  id: 'passkeys',
  title: 'Passkey Authentication',
  icon: Passkeys,
  color: 'blue',
  isReleased: true,
}

const documentSignatureApp: AppInfo = {
  id: 'document-signature',
  title: 'Document Signature',
  icon: DocumentSignature,
  color: 'orange',
  isReleased: true,
}

const eFormApp: AppInfo = {
  id: 'e-form',
  title: 'Secure eForm',
  icon: EForm,
  color: 'rose',
  isReleased: true,
}

const oneTimePasscodeApp: AppInfo = {
  id: 'one-time-passcode',
  title: 'One Time Passcode',
  icon: OneTimePasscode,
  color: 'purple',
  isReleased: true,
}

const paymentsApp: AppInfo = {
  id: 'payments',
  title: 'Payments',
  icon: Payments,
  color: 'green',
  isReleased: true,
}

const identityVerificationApp: AppInfo = {
  id: 'identity-verification',
  title: 'Identity Verification',
  icon: IdentityVerification,
  color: 'copper',
  isReleased: false,
}

const gatewayPaymentsApp: AppInfo = {
  id: 'gateway-payments',
  title: 'Gateway Payments',
  icon: GatewayPayments,
  color: 'teal',
  isReleased: false,
}

export type AppInfo = {
  id: App
  title: string
  icon: FC<React.SVGProps<SVGSVGElement>>
  color: AppColor
  isReleased: boolean
}

export type App =
  | 'document-signature'
  | 'e-form'
  | 'gateway-payments'
  | 'identity-verification'
  | 'one-time-passcode'
  | 'passkeys'
  | 'payments'

const apps: AppInfo[] = [
  passkeysApp,
  oneTimePasscodeApp,
  documentSignatureApp,
  eFormApp,
  paymentsApp,
  identityVerificationApp,
  gatewayPaymentsApp,
]

export const appNames = apps.reduce((acc, app) => ({ ...acc, [app.id]: app.title }), {} as Record<App, string>)
export const appIcons = apps.reduce(
  (acc, app) => ({ ...acc, [app.id]: app.icon }),
  {} as Record<App, FC<React.SVGProps<SVGSVGElement>>>
)

export default apps
